import Carga from '@/model/resource/Carga'
import DeliverySacCpfCnpjSchema from '@/schema/DeliverySacAttemptResponse.schema'
import {ID, Resource, ResponseSerialize} from 'simpli-web-sdk'
import SacResponse from '@/model/response/SacResponse'

export default class DeliverySacAttemptResponse extends Carga {

    readonly $name: string = 'DeliverySacAttemptResponse'
    readonly $endpoint: string = '/user/carga/sac/guest/cpfCnpj'

    get $id() {
        return this.id
    }
    set $id(val: ID) {
        this.id = val
    }

    get $schema() {
        return DeliverySacCpfCnpjSchema(this)
    }

    id: ID = 0

    @ResponseSerialize(SacResponse)
    sacResponse: SacResponse | null = null

}
